import { render, staticRenderFns } from "./membership-list.vue?vue&type=template&id=dc1189ba"
import script from "./membership-list.vue?vue&type=script&lang=js"
export * from "./membership-list.vue?vue&type=script&lang=js"
import style0 from "./membership-list.vue?vue&type=style&index=0&id=dc1189ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports